import { useContext } from "react";
import { DriveTrainListContext } from "../context";

export const useDriveTrain = () => useContext(DriveTrainListContext);
